import type { ID } from '@octopus-do/octopus-project-core'
import { LoaderActions } from '@store/loaders'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { managerActions } from '@store/reducers/manager/actions'
import { PROJECT_HISTORY_INIT } from '@store/reducers/manager/middleware/history/types'
import { initProjectActionsSaga } from '@store/reducers/manager/sagas/initProjectActionsSaga'
import { CanvasActionTypes } from '@storeOld/reducers/canvas/canvas'
import { call, put, select } from 'redux-saga/effects'

export function* createProjectAndSaveSaga({
  payload: { teamId },
}: ReturnType<typeof managerActions.createProjectAndSaveSaga>) {
  yield put(LoaderActions.set('project_create'))

  try {
    yield call(initProjectActionsSaga)

    const tabId: ID = yield select(
      migrationProjectSelector.getActiveOrFirstTabId
    )

    yield put({
      type: CanvasActionTypes.SET_ACTIVE_TAB,
      payload: { id: tabId },
    })

    yield put(managerActions.saveProjectSaga({ teamId }))

    yield put({
      type: PROJECT_HISTORY_INIT,
    })
  } catch (error) {
    console.error('Error creating project boilerplate:', error)
  } finally {
    yield put(LoaderActions.unset('project_create'))
  }
}
